import * as React from 'react';
import InsiderTransactionsFmpDataGrid from './InsiderTransactionsFmpDataGrid';

function InsiderTransactions({data} :any) {
  return (
    <div className="col-lg-12 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Insider Transactions</h4>
          <div>
            <InsiderTransactionsFmpDataGrid data={data?.insider_transactions_fmp} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default InsiderTransactions;
